<div class="login-box">
  <div class="login-logo">
    <img height="60" src="{{logoPath}}" />
  </div>
  <div class="login-box-body">
    <form [formGroup]="esqueciSenha">
      <div
        class="has-feedback mb-3"
        [class.has-error]="username.invalid && username.dirty"
      >
        <input
          type="text"
          class="form-control"
          placeholder="Usuário"
          formControlName="username"
          *ngIf="!isSent()"
        />
        <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
        <div class="help-block" [hidden]="username.valid || username.pristine">
          Usuário inválido
        </div>
        <p *ngIf="isSent()">E-mail para recuperação de senha enviado!</p>
      </div>
      <div class="d-flex justify-content-center">
        <button
          *ngIf="!isSent()"
          class="btn btn-primary btn-block btn-flat"
          (click)="send()"
          [disabled]="isSending"
        >
          Enviar
        </button>
      </div>
      <a href="/login" *ngIf="isSent()">Retornar</a>
    </form>
  </div>
</div>
